import { FC } from 'react';
import { AccountChartInner, AccountChartInnerProps } from './AccountChartInner';
import { ChartContainer, ChartContainerProps } from '../../Chart/NetWorthChart/ChartContainer';

interface AccountChartProps
  extends AccountChartInnerProps,
    Pick<ChartContainerProps, 'defaultRangeFilter' | 'defaultChartRangeOption'> {
  accountID: string;
}

export const AccountChart: FC<AccountChartProps> = ({
  groupID,
  accountID,
  householdID,
  defaultRangeFilter,
  defaultChartRangeOption,
}) => {
  return (
    <ChartContainer
      ownerID={accountID}
      defaultRangeFilter={defaultRangeFilter}
      defaultChartRangeOption={defaultChartRangeOption}
    >
      <AccountChartInner groupID={groupID} householdID={householdID} />
    </ChartContainer>
  );
};
